import React, { useState } from "react";
import Visible from "react-visibility-sensor";
import { Box, Stack } from "@origin-digital/ods-core";
import { RegisterSection } from "./RegisterSection";
import { config } from "src/config";
import { FAQSection } from "./FAQSection";
import { HeroSection } from "./HeroSection";
import heroAssets from "./HeroSection/assets.json";
import { HowSection } from "./HowSection";
import { ParagraphSection } from "./ParagraphSection";
import { MediaSection } from "./MediaSection";
import { ISpikeContent } from "../../types";
import { WhySection } from "./WhySection";
import styled from "styled-components";
import { CustomerSection } from "./CustomerSection";

const VisibleHandle = styled.div`
  height: 1px;
  background: transparent;
  margin-top: -10px;
`;

export const Spike = (props: ISpikeContent) => {
  const { heroContent, tileParagraphContent, registerContent } = props;
  const [isHeroVisible, setIsHeroVisible] = useState(true);
  const [isFAQVisible, setIsFAQVisible] = useState(true);

  return (
    <Box data-id="origin-spike">
      <Stack space="xsmall">
        <Stack
          space={{
            sm: "none",
            xs: "none",
          }}
        >
          <HeroSection content={heroContent} assets={heroAssets} />
          <Visible onChange={setIsHeroVisible} partialVisibility>
            <VisibleHandle />
          </Visible>
          <div id="video">
            <MediaSection />
          </div>
          <HowSection />
        </Stack>
        <Stack
          space={{
            sm: "none",
            xs: "xsmall",
          }}
        >
          <CustomerSection />
        </Stack>
        <div id="eligible">
          <ParagraphSection
            //@ts-ignore
            content={tileParagraphContent}
          />
        </div>
      </Stack>
      <Stack space="xsmall">
        <WhySection />
        <Visible onChange={setIsFAQVisible}>
          <FAQSection />
        </Visible>
      </Stack>
      {!isHeroVisible && (
        <Box
          position="sticky"
          width="full"
          style={{
            bottom: 0,
            boxShadow: isFAQVisible
              ? "0px 0px 0px 1px rgb(0 0 0 / 12%)"
              : "0 1px 8px 0 rgba(0, 0, 0, 0.12), 0 3px 4px 0 rgba(0, 0, 0, 0.14), 0 3px 3px -2px rgba(0, 0, 0, 0.2)",
          }}
        >
          <RegisterSection
            link={
              config.env === "prod"
                ? registerContent.cta.prodLocation
                : registerContent.cta.nonProdLocation
            }
          />
        </Box>
      )}
    </Box>
  );
};
